import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'eye-icon',
  templateUrl: './eye-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class EyeIconComponent {}
